<template>
    <div>
        <ui-modal class="inspection-modal" ref="modal" :title="modalTitle" @hide="reset" size="xlarge" dismiss-on="close-button esc">
            <ui-tabs ref='tabs' v-if="!isLoading" background-color="clear" @tab-change="tabChange" style="margin-bottom: 0;">
                <ui-tab ref="inspectionDetail" title="Inspection Detail" v-if="!isLoading && hasQuestionGroups">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col" style="padding-left: 0; margin-top: 2rem; margin-bottom: 2rem; text-align: center;">
                                <div class="registration x-large">
                                    {{ inspection.listing.registration }}
                                </div>
                                <h1 style="display: inline-block; margin-left: 2rem; vertical-align: middle;">{{ inspection.listing.title }}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col" style="padding-left: 0; padding-right: 0;">
                                <hr>
                            </div>
                        </div>
                    </div>
                    <div v-for="group in inspection.type.question_groups" class="container-fluid" style="margin-bottom: 3rem">
                        <div class="row align-items-center" style="background: #f0f0f0;">
                            <div class="col" style="padding: 1.5rem 1rem">
                                <h5 style="margin-bottom: 0;">{{ group.name }}</h5>
                            </div>
                            <div class="col text-right">
                                <ui-button
                                    color="green"
                                    type="secondary"
                                    v-if="group.allow_bulk_completion"
                                    icon="check"
                                    @click="passGroup(group.id)"
                                    :disabled="isSaving"
                                >Pass Group</ui-button>
                            </div>
                        </div>
                        <template v-for="question in group.questions">
                            <component
                                :is="questionTypeComponent(question)"
                                :question="question"
                                :answer="answers[question.id]"
                                :is-saving="isSaving"
                                @input="answerUpdated"
                            ></component>
                        </template>
                    </div>
                </ui-tab>
                <ui-tab v-if="inspection && !inspection.booking" :title="'Related Jobs (' + (inspection ? inspection.tasks.length : 0) + ')'">
                    <task-card 
                        v-if="inspection"
                        ref="tasksCard" 
                        :instance="inspection.listing"
                        :value="inspection.tasks"

                        :allow-task-addition="true"
                        :allow-vehicle-editing="false"
                        :default-task-attributes="{ type: TaskTypes.JOB, instance_id: inspection.instance_id, inspection_id: inspection.id }"
                        @updated="taskUpdated"
                        @destroyed="taskDestroyed"
                    ></task-card>
                </ui-tab>
            </ui-tabs>
            <cog-loader v-if="isLoading" style="margin-top: 3rem;"></cog-loader>

            <div slot="footer" style="width: 100%; text-align: right; margin-top: 1rem; margin-bottom: 1rem;">
                <div v-if="!isCurrentlyTasksTab">
                    <ui-button :disabled="isLoading || isSaving" :loading="isPrinting" @click="printInspection">
                        Print Inspection
                    </ui-button>
                    <ui-button
                        color="green"
                        type="secondary"
                        v-if="this.inspection && !this.inspection.completed_at"
                        icon="checklist"
                        @click="passAll()"
                        :disabled="canSave || isLoading || isSaving"
                         style="float: left;"
                    >Pass all questions</ui-button>
                    <ui-button v-if="this.inspection && this.inspection.completed_at && !isLoading" icon="undo" :disabled="isSaving" @click="resetInspection" style="float: left;">
                        Reset Inspection
                    </ui-button>
                    <ui-button :disabled="!canSave || isLoading" :loading="isSaving" @click="saveInspection">
                        Save Detail
                    </ui-button>
                </div>
                <div v-else>
                    <ui-button icon="add" :disabled="!canSave || isLoading" @click="addTask" color="green">
                        Add Task
                    </ui-button>
                </div>
            </div>
        </ui-modal>
    </div>
</template>

<style lang="scss">
    .inspection-modal {
        textarea:focus, textarea:active { outline: none; }

        h5 { font-weight: 600; }

        .ui-tabs__body {
            border-left: none;
            border-right: none;
            padding-left: 0;
            padding-right: 0;
        }
    }
</style>

<script>
import {
    InspectionResource,
    AnswerSchema,
    AnswerOutcomes,
    TyreStateQuestionHandle,
    TyreStateAnswerSchema, BrakeStateAnswerSchema,
    DefectGroupSchema
} from '../../classes/Api/Inspection'
    import TaskCard from '../elements/TaskCard'
    import { TaskTypes } from '../../classes/Api/Task'
    import DefaultQuestionType from "./DefaultQuestionType";
    import {cloneDeep, isEmpty, sortBy, toArray} from "lodash";
    import TyreStateQuestionType from "./TyreStateQuestionType";
import BrakePadStateQuestionType from "./BrakePadStateQuestionType";
import DealerKit from "../../api";
import DefectGroupQuestionType from "./DefectGroupQuestionType";
import TextContentQuestionType from "./TextContentQuestionType.vue"
import ProductEvents from "../../integrations/product-events";

    export default {
        components: {
            TaskCard
        },
        data() {
            return {
                inspection: null,
                answers: {},
                isLoading: true,
                isSaving: false,
                isPrinting: false,
                TaskTypes,
                tabIndex: 1,
            }
        },
        methods: {
            printInspection() {
                this.isPrinting = true

                this.$root.printElementViaCanvas(this.$refs.inspectionDetail.$el).then(() => {
                    this.isPrinting = false
                })
            },
            tabChange(i) {
                this.tabIndex = this.$refs.tabs.activeTabIndex
            },
            addTask() {
                this.$refs.tasksCard.addTask()
            },
            taskUpdated(t) {
                this.loadInspection(this.inspection.id)
            },            
            taskDestroyed(t) {
                this.loadInspection(this.inspection.id)
            },
            passGroup(group_id) {
                let group = this.inspection.type.question_groups.find(i => {
                    return parseInt(i.id) === parseInt(group_id)
                })

                for (let i in group.questions) {
                    if (group.questions[i].type === 'text') {
                        this.answers[group.questions[i].id].outcome = AnswerOutcomes.OUTCOME_PASSED
                    }
                }
            },
            passAll() {
                if (confirm('Are you sure you want to mark all questions as passed?')) {
                    let unpassable = []

                    this.inspection.type.question_groups.forEach((group) => {
                        if (group.allow_bulk_completion) {
                            this.passGroup(group.id)
                        } else {
                            unpassable.push(`- ${group.name}`)
                        }
                    })

                    if (unpassable.length > 0) {
                        alert("The following groups cannot be completed in bulk, you will need to manually complete them:\n\n" + unpassable.join("\n"))
                    }
                }
            },
            answerInput(question) {
                let answer = this.inspection.answers.find(a => a.question_id === question.id)

                if (!answer) {
                    let additional_data = null

                    if (question.type === 'tyre.state') {
                        additional_data = TyreStateAnswerSchema()
                    } else if (question.type === 'brake.state') {
                        additional_data = BrakeStateAnswerSchema()
                    } else if (question.type === 'bodywork.defect.group') {
                        additional_data = DefectGroupSchema({ type: 'bodywork-v1', outcome: AnswerOutcomes.OUTCOME_SKIPPED })
                    } else if (question.type === 'interior.defect.group') {
                        additional_data = DefectGroupSchema({ type: 'interior-v1', outcome: AnswerOutcomes.OUTCOME_SKIPPED })
                    }

                    answer = AnswerSchema({ question_id: question.id, additional_data })
                }

                this.$set(this.answers, question.id, cloneDeep(answer));
            },
            open(id) {
                this.reset();

                this.isLoading = true

                this.$refs['modal'].open();

                ProductEvents.emit('inspection:opened', {id});

                this.loadInspection(id)
            },
            loadInspection(id) {
                return DealerKit.inspections.findInspection(id).then(response => {
                    this.inspection = response.data.data

                    this.syncAnswersWithOriginal()

                    this.isLoading = false
                }, e => { handleApiError(e); this.isLoading = false })
            },
            syncAnswersWithOriginal() {
                this.answers = {}

                this.inspection.type.question_groups.forEach(group => {
                    group.questions.forEach(question => {
                        this.answerInput(question)
                    })
                })
            },
            saveInspection(closeOnSave = true) {
                this.isSaving = true

                return DealerKit.inspections.completeInspection(this.inspection.id, { answers: this.answers })
                    .then(response => {
                        this.isSaving = false

                        this.$emit('saved');

                        if (closeOnSave) {
                            this.$refs.modal.close()
                        }
                    }, e => { handleApiError(e); this.isSaving = false })
            },
            saveQuietly() {
                this.saveInspection(false).then(() => {
                    this.loadInspection(this.inspection.id)
                })
            },
            resetInspection() {
                if (confirm('Are you sure you want to reset the inspection status?')) {
                    this.isSaving = true

                    DealerKit.inspections.resetInspection(this.inspection.id).then(response => {
                        this.isSaving = false

                        this.$emit('reset');

                        this.$refs.modal.close()
                    });
                }
            },
            reset() {
                this.isLoading = false
                this.inspection = null
                this.questions = {}
                this.answers = {}
                this.tabIndex = 1
            },
            questionTypeComponent(question) {
                if (question.type === TyreStateQuestionHandle) {
                    return TyreStateQuestionType
                } else if (question.type === 'brake.state') {
                    return BrakePadStateQuestionType
                } else if (question.type === 'bodywork.defect.group' || question.type === 'interior.defect.group') {
                    return DefectGroupQuestionType
                } else if (['text.box', 'text.area'].includes(question.type)) {
                    return TextContentQuestionType
                }

                return DefaultQuestionType;
            },
            answerUpdated(answer) {
                this.answers[answer.question_id] = answer
            }
        },
        computed: {
            hasQuestionGroups() {
                return this.inspection && this.inspection.type.question_groups.length > 0
            },
            isCurrentlyTasksTab() {
                return 0 === this.tabIndex
            },
            unansweredQuestionCount() {
                let answers = toArray(this.answers)
                return answers.filter(item => {
                    return isEmpty(item.outcome)
                }).length
            },
            unansweredQuestions() {
                let answers = toArray(this.answers)
                return answers.filter(item => {
                    return isEmpty(item.outcome)
                })
            },
            canSave() {
                return !this.isLoading && !this.isSaving && 0 === this.unansweredQuestionCount
            },
            modalTitle() {
                return this.inspection ? this.inspection.type.name : 'Loading'
            }
        }
    }
</script>